import { AxiosError } from "axios";
import api, { API_VERSIONS } from "@/config/api";
import { recoverTokenInfo } from "@/utils/recoverTokenInfo";
import type { CreateMinutesData } from "@/hooks/mutations/usePostCreateMinutes";

const postCreateTranscript = async (data: CreateMinutesData): Promise<boolean | AxiosError> => {
  try {
    const initialToken = recoverTokenInfo();
    const res = await api.post<boolean | AxiosError>(`/${API_VERSIONS.v0}/recording/CreateTranscript`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${initialToken}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error creating transcript:", error);
    throw error;
  }
};

export default postCreateTranscript;
